import React from 'react';
import { 
  TextField, 
  Button, 
  Grid, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Box
} from '@mui/material';

const OperationForm = ({ 
  operation, 
  onChange, 
  onSubmit, 
  submitLabel = 'Guardar', 
  onCancel,
  isSubmitting = false 
}) => {
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({
      ...operation,
      [name]: name === 'linesPerGroup' ? parseInt(value) : value
    });
  };

  return (
    <Box component="form" onSubmit={onSubmit} sx={{ mt: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            name="name"
            label="Nombre"
            value={operation.name}
            onChange={handleChange}
            fullWidth
            required
            disabled={!!operation.id || operation.editMode} // Deshabilitar cambio de nombre en edición
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="prompt"
            label="Instrucción (Prompt)"
            value={operation.prompt}
            onChange={handleChange}
            fullWidth
            required
            multiline
            rows={2}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="format"
            label="Formato"
            value={operation.format}
            onChange={handleChange}
            fullWidth
            required
            multiline
            rows={2}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="model"
            label="Modelo"
            value={operation.model}
            onChange={handleChange}
            fullWidth
            required
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required>
            <InputLabel id="provider-label">Proveedor</InputLabel>
            <Select
              labelId="provider-label"
              name="provider"
              value={operation.provider}
              label="Proveedor"
              onChange={handleChange}
            >
              <MenuItem value="ollama">Ollama</MenuItem>
              <MenuItem value="openai">OpenAI</MenuItem>
              <MenuItem value="anthropic">Anthropic</MenuItem>
              <MenuItem value="google">Google</MenuItem>
              <MenuItem value="huggingface">Hugging Face</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="linesPerGroup"
            label="Líneas por grupo"
            type="number"
            value={operation.linesPerGroup}
            onChange={handleChange}
            fullWidth
            required
            inputProps={{ min: 1 }}
          />
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            {onCancel && (
              <Button 
                onClick={onCancel}
                variant="outlined"
                disabled={isSubmitting}
              >
                Cancelar
              </Button>
            )}
            <Button 
              type="submit" 
              variant="contained" 
              color="primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Guardando...' : submitLabel}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OperationForm; 